import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Chapters } from './components/Chapters';
import { PreviewCarousel } from './components/PreviewCarousel';
import { SinVsCon } from './components/SinVsCon';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FooterTestimonials } from './components/FooterTestimonials';
import { Objections } from './components/Objections';
import { Popup } from './components/Popup';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    const w = window as any;
    const d = document;
    if (w.fbq) {
      try {
        w.fbq('track', 'PageView');
      } catch {}
      return;
    }
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = d.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const parent = d.head || d.body || d.documentElement;
    if (parent) {
      parent.appendChild(script);
    }
    try {
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
    } catch {}
  }, []);
  return <div className="min-h-screen bg-pastel-50 font-sans overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Problems data-id="element-2" />
      <Chapters data-id="element-3" />
      <PreviewCarousel data-id="element-4" />
      <SinVsCon data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <FooterTestimonials data-id="element-8" />
      <Objections data-id="element-9" />
      <Footer data-id="element-10" />
      <Popup data-id="element-11" />

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-pastel-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-12">
        <a href="#compra" className="block w-full py-3 px-4 bg-navy-800 hover:bg-navy-700 text-white font-bold text-center rounded-lg shadow-lg transition-colors" data-id="element-13">
          🔒 Quiero mi Manual ahora
        </a>
      </div>
    </div>;
}